import { normalizeDateTaken } from '../../utils/dateTaken.js';

/**
 * Date/Time field formatters
 */

/**
 * Standard ISO date display formatter
 */
export const dateDisplayFormatter = (value) => {
  if (value == null) return '-';
  const date = new Date(value);
  return isNaN(date.getTime()) ? '-' : date.toLocaleString();
};

/**
 * Converts ISO date format to EXIF date format
 * ISO: YYYY-MM-DDTHH:mm:ss
 * EXIF: YYYY:MM:DD HH:MM:SS
 */
export const dateToExifFormatter = (value) => {
  const normalized = normalizeDateTaken(value);
  if (!normalized) return null;
  return normalized.replace(/-/g, ':').replace('T', ' ');
};

/**
 * Converts EXIF date format to ISO date format
 * EXIF: YYYY:MM:DD HH:MM:SS
 * ISO: YYYY-MM-DDTHH:mm:ss
 */
export const dateFromExifFormatter = (value) => {
  return normalizeDateTaken(value);
};

/**
 * Returns standard date field formatters
 */
export function getDateFormatters(options = {}) {
  const { defaultValue = null } = options;
  return {
    formatForDisplay: dateDisplayFormatter,
    formatForExif: dateToExifFormatter,
    formatFromExif: dateFromExifFormatter,
    defaultValue
  };
}
